<template>
	<el-form ref="form" :model="form"  :rules="rules" :inline="true" label-width="100px" size="mini" @submit.prevent="onSubmit" style="margin:10px;width:80%;min-width:800px;">
		  <el-form-item label="部门" prop="visitedDep">
			<el-select v-model="form.visitedDep" @change="getOrganize">
				<el-option v-for="org in organizes" :key="org.financeCode" :label="org.dept" :value="org.financeCode"></el-option>
			</el-select>
		    </el-form-item>   
        <el-form-item label="部门业务">
				<el-tag type="info" style="width:825px;height:400px">{{form.visitContent}}</el-tag>
		</el-form-item><br>
        <el-col :span="24" style="text-align:center">
        <el-form-item>
         <el-button type="primary" @click="onSubmit('form')" >确定</el-button>
        </el-form-item>
        </el-col>
		<el-dialog
		title="提示"
		:visible.sync="dialogVisible"
		width="30%"
		:before-close="handleClose">
		<span>请选择部门</span>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		</span>
	</el-dialog>
	</el-form>
	
</template>

<script>
import { RequestPost, url } from '../../api/api'
	export default {
		data() {
			return {
				form: {
					visitor: '',
					visitorIdcard: '',
					visitorDep: '',
					visitTime: '',
					visitContent:'部门简介：。。。。。。。。。。。。。。。。。。。。。。。。。。',
					visitedPerson:'',
					visitedDep:'',
				},
				rules:{
					visitedDep:[ {
                                required: true, //是否必填
                                message: "部门不能为空", //规则提示
                                trigger: "blur" //何事件触发
                            }]
						},
				ifHide:true,
				organizes:[],
				dialogVisible:false
			}
		},
		methods: {
			onSubmit(form) {
			    console.log(this.form)
				if(this.form.visitedDep=="" || this.form.visitedDep==null){
					this.dialogVisible=true;
				}else{
					this.$router.push({path: '/commission_order', query:{depId:this.form.visitedDep}});
				}
					
			},
			getOrganize(){
				  //this.$axios.post(url+"/app/visit/findDept").then(response => {
				  this.$axios.get(url+"/deptInfor/findAll").then(response => {
					  this.organizes=response.data.data.list;
                      //console.log(this.organizes)
                }).catch(error => {
                  //console.log("aaa");
          })
			},
			getLoginInfo(){
				//获取登录人员的信息
				 this.id = sessionStorage.getItem("userId");
				 this.form.visitPerson=sessionStorage.getItem("userId");
				var person = {
					id:this.id,
				}
				RequestGet("/customer/findByid",person).then(response => {
					console.log(response);
				this.form.visitor=response.data.name;
				this.form.visitorIdcard=response.data.idcard;
				this.form.visitorDep=response.data.enterpriseName;
				this.form.visitorPhone=response.data.phone;
				}).catch(error => {
				//this.$router.push({ path: '/login' });
				})
			},
			handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
		},
		created:function(){
		this.getOrganize();
	},
	}

</script>


// WEBPACK FOOTER //
// chooseDept.vue?cacd85ea